function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import { stateGo } from 'redux-ui-router';
import i18n from 'invision-core/src/components/i18n/i18n';
import { NON_BULK_SERVICE_STATUSES } from 'invision-core/src/constants/status.constants';
import CustomerLocaleKeys from '../../../../../../locales/keys';
import { IsPIIDataAccessEnabledSelector, CurrentCustomerIdSelector } from '../../../../../../reducers/selectors/customer.selectors';
import { SERVICE_ADD_ON_PRODUCTS_ORDERING_PAGE_ROUTE } from '../../../../../../reactRoutes';
var ServiceFeaturesController = /*#__PURE__*/function () {
  function ServiceFeaturesController($ngRedux) {
    _classCallCheck(this, ServiceFeaturesController);
    Object.assign(this, {
      $ngRedux: $ngRedux,
      CustomerLocaleKeys: CustomerLocaleKeys
    });
  }
  return _createClass(ServiceFeaturesController, [{
    key: "$onInit",
    value: function $onInit() {
      var _this = this;
      var controllerActions = {
        stateGo: stateGo
      };
      var mapStateToProps = function mapStateToProps(store) {
        return {
          currentCustomerId: CurrentCustomerIdSelector(store),
          isPIIDataAccessEnabled: IsPIIDataAccessEnabledSelector(store)
        };
      };
      this.disconnectRedux = this.$ngRedux.connect(mapStateToProps, controllerActions)(function (state, actions) {
        _this.state = state;
        _this.actions = actions;
      });
      this.moreMenuItems = this.getMoreMenuItems();
    }
  }, {
    key: "getMoreMenuItems",
    value: function getMoreMenuItems() {
      var _this2 = this;
      var moreMenuItems = [];
      if (this.state.isPIIDataAccessEnabled) {
        var isSelectedServiceSuspended = this.serviceStatus === NON_BULK_SERVICE_STATUSES.SUSPENDED;
        moreMenuItems.push({
          title: i18n.translate(CustomerLocaleKeys.MANAGE_ADD_ONS),
          action: function action(item) {
            if (!item.isLocked) {
              // TODO: handle device/inventory add-ons also?
              _this2.actions.stateGo(SERVICE_ADD_ON_PRODUCTS_ORDERING_PAGE_ROUTE, {
                customerId: _this2.state.currentCustomerId,
                serviceIdentifierValue: _this2.serviceIdentifier.Value,
                serviceId: _this2.serviceId,
                serviceAttributeId: _this2.serviceIdentifier.ServiceAttributeId
              });
            }
          },
          isLocked: isSelectedServiceSuspended,
          disabled: isSelectedServiceSuspended
        });
      }
      return moreMenuItems;
    }
  }, {
    key: "onMoreMenuItemSelected",
    value: function onMoreMenuItemSelected(_ref) {
      var itemProps = _ref.item;
      itemProps.action(itemProps);
    }
  }, {
    key: "$onDestroy",
    value: function $onDestroy() {
      this.disconnectRedux();
    }
  }]);
}();
export default {
  bindings: {
    currencyCode: '<',
    deviceAddons: '<',
    physicalInventoryServiceIdentifier: '<',
    serviceAddons: '<',
    serviceId: '<',
    serviceIdentifier: '<',
    serviceStatus: '<'
  },
  template: require('./service.features.html'),
  controller: ServiceFeaturesController
};